import { type UseQueryResult, useQuery } from 'react-query';
import { TenantStateService } from '../../services/wealthlane-identity-services';

const useGetSandboxStateOptions = (
    handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
    | Array<{
        label: string;
        value: string | number;
    }>
    | undefined,
    unknown
> => {
    const sandboxStateOptions = useQuery(
        ['getSandboxStateOptions'],
        async () => {
            return await handleRequest(TenantStateService.getApiIdentityApiSandboxStateOptions());
        },
        {
            select: (data) => {
                return data?.map((item) => {
                    return {
                        label: item.name ?? '',
                        value: item.id ?? '',
                    };
                });
            },
        }
    );

    return sandboxStateOptions;
};

export default useGetSandboxStateOptions;
